/** Delivery & Value — overview landing + drill-down sub-pages. */

export const DELIVERY_FLOWS = [
  { id: "overview", label: "Overview" },
  { id: "value", label: "Value & WHY" },
  { id: "gates", label: "Gates & GO" },
  { id: "track", label: "Delivery track" },
  { id: "packages", label: "Wave packages" },
  { id: "dependencies", label: "Dependencies" },
];

export const DELIVERY_DRILL = DELIVERY_FLOWS.filter((f) => f.id !== "overview");

export const DELIVERY_FOCUS_TITLE = {
  overview: "Delivery & value at a glance",
  value: "Expected vs actual value",
  gates: "G3–G8 sign-off & production GO",
  track: "Delivery track",
  packages: "Wave & GO package",
  dependencies: "Dependency impact",
};

export const DELIVERY_FOCUS_DETAIL = {
  overview: "Wave status, deployment state and drill-down — one topic per screen.",
  value: "Beginning WHY, TCO bars and KPI before/after — G8 records actuals.",
  gates: "Gate sign-offs, production GO and G8 business validation.",
  track: "MDR → wave → gates → deploy → hypercare → G8 success ladder.",
  packages: "Lean work packages and G7 cutover/rollback owner.",
  dependencies: "Coupling graph — click a node for wave and gate impact.",
};

/** Legacy ?disclosure=l1|l2|l3 from RoleHomeShell / StorySpine. */
export function resolveDeliveryFocus(explicit) {
  if (!explicit) return "overview";
  const legacy = {
    l1: "value",
    l2: "gates",
    l3: "track",
    l4: "value",
    deploy: "gates",
    prove: "value",
  };
  return legacy[explicit] || explicit;
}
